export function localeUpdate() {
    return {
        relativeTime: {
            future: 'in %s',
            past: '%s',
            s: 'a few secs',
            ss: '%d secs',
            m: '%d min',
            mm: '%d mins',
            h: '%d hr',
            hh: '%d hrs',
            d: '%d d',
            dd: '%d d',
            M: '%d m',
            MM: '%d m',
            y: 'a year',
            yy: '%d years'
        }
    };
}
